import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ReopenStageDialogComponent } from 'src/app/requests/esp/application/application-stages-details/reopen-stage-dialog/reopen-stage-dialog.component';

@Component({
  selector: 'xcdrs-language-not-available-dialog',
  templateUrl: './language-not-available-dialog.component.html',
  styleUrls: ['./language-not-available-dialog.component.scss']
})
export class LanguageNotAvailableDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any,
    private _dialogRef: MatDialogRef<ReopenStageDialogComponent>,
  ) { }

  ngOnInit(): void {
  }

  proceed(){
    this._dialogRef.close(true);
  }

}
